module.exports = __webpack_public_path__ + "media/private_home/NEW_PRODUCTS-6f0fc902.jpg";